export default __webpack_public_path__ + "static/media/bantu-logo.e89558a9.png";